export const numberReg = /^-?[1-9][0-9]?.?[0-9]*$/
export const intReg = /^-?[1-9][0-9]*$/
export const phoneReg = /^1[0-9]{10,10}$/
export const emailReg = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
export const pwdReg = /^.{6,18}$/
export const inviteCodeReg = /^[a-zA-Z0-9]{6,16}$/
export const IDcardReg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|30|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/
export type ValidateRules = ValidateRule[]
export interface ValidateRule {
  /**
   * 验证数据对象 key值
   */
  name: string
  /**
   * 数据验证类型
   */
  type?:
    | 'required'
    | 'equals'
    | 'eq'
    | 'number'
    | 'int'
    | 'email'
    | 'phone'
    | 'pwd'
    | 'range'
    | 'inviteCode'
    | 'lengthRange'
    | 'regex'
    | 'IDcard'
  errmsg?: string
  min?: number
  max?: number
  eq?: boolean
  eqName?: string
  required?: boolean
  regex?: RegExp
}
export function isNumber(val: string) {
  return numberReg.test(val)
}
export function isInt(val: string) {
  return intReg.test(val)
}
export function isPhone(val: string) {
  return phoneReg.test(val)
}
export function isEmail(val: string) {
  return emailReg.test(val)
}
export function isPwd(val: string) {
  return pwdReg.test(val)
}
export function isInviteCode(val: string) {
  return inviteCodeReg.test(val)
}
export function isIDcard(val: string) {
  return IDcardReg.test(val)
}
export function validate(data: any, rules: ValidateRules) {
  let res = {
    isOk: true,
    name: '',
    errmsg: ''
  }
  if (!rules || !rules.length) {
    return res
  }
  for (const rule of rules) {
    if (!rule || !rule.name) {
      continue
    }

    if (!data[rule.name]) {
      if (rule.type === 'required' || rule.required) {
        res = {
          isOk: false,
          name: rule.name,
          errmsg: rule.errmsg || '请正确输入所有数据'
        }
        return res
      }
      continue
    }
    const val = data[rule.name]
    const length = data[rule.name] ? data[rule.name].length : 0

    switch (rule.type) {
      case 'equals':
      case 'eq':
        if (!rule.eqName) break
        if (data[rule.name] !== data[rule.eqName]) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || '数据不一致'
          }
        }
        break
      case 'number':
        if (!numberReg.test(data[rule.name])) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || '请填写数字'
          }
        }
        break
      case 'int':
        if (!intReg.test(data[rule.name])) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || '请填写整数'
          }
        }
        break
      case 'phone':
        if (!phoneReg.test(data[rule.name])) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || '请填写正确的手机号'
          }
        }
        break
      case 'IDcard':
        if (!IDcardReg.test(data[rule.name])) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || '请填写正确身份证号'
          }
        }
        break
      case 'email':
        if (!emailReg.test(data[rule.name])) {
          res = {
            name: rule.name,
            isOk: false,
            errmsg: rule.errmsg || '请填写正确的电子邮箱地址'
          }
        }
        break
      case 'pwd':
        if (!pwdReg.test(data[rule.name])) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || '请按照提示填写密码'
          }
        }
        break
      case 'inviteCode':
        if (!inviteCodeReg.test(data[rule.name])) {
          res = {
            name: rule.name,
            isOk: false,
            errmsg: rule.errmsg || '请填写正确的邀请码'
          }
        }
        break
      case 'range': // 数字类型的值取值范围
        if (val) {
          if (numberReg.test(val)) {
            if (rule.min && val < rule.min) {
              res = {
                name: rule.name,
                isOk: false,
                errmsg: rule.errmsg || `填写数字小于${rule.min}`
              }
            } else if (rule.max && val > rule.max) {
              res = {
                name: rule.name,
                isOk: false,
                errmsg: rule.errmsg || `填写数字大于${rule.max}`
              }
            }
          } else {
            res = {
              isOk: false,
              name: rule.name,
              errmsg: rule.errmsg || '请输入'
            }
          }
        }
        break
      case 'lengthRange':
        if (rule.min && length < rule.min) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || `输入长度不得小于${rule.min}`
          }
        } else if (rule.max && length > rule.max) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || `输入长度不得大于${rule.max}`
          }
        }
        break
      case 'regex':
        if (rule.regex && !rule.regex.test(data[rule.name])) {
          res = {
            isOk: false,
            name: rule.name,
            errmsg: rule.errmsg || '数据格式错误'
          }
        }
        break
    }
    // 发现任何一个错误就立即返回，后面的不再判断
    if (!res.isOk) {
      if (!res.errmsg) {
        res.errmsg = '请正确输入所有数据' //默认提示
      }
      return res
    }
  }
  return res
}
